// @ts-nocheck
import { sendMessage } from './send-message';

export function parseMessage(data) {
  try {
    return JSON.parse(data);
  } catch (e) {
    console.warn('Cannot parse incoming message, it is not a valid JSON', data);
    return null;
  }
}

export function sendError(ws, error) {
  console.error('websocket:error', error);
  sendMessage(ws, { cmd: 'error', error });
}
